export function buildArticleClipboardText(story: {
  title?: string;
  url?: string;
  summary?: string;
  estimated_reading_minutes?: number | null;
}): string {
  const title = story.title || '(Untitled)';
  const mins = story.estimated_reading_minutes;
  const timeLabel = mins != null ? `${mins} minute read` : '';
  const summary = (story.summary || '')
    .replace(/<[^>]*>/g, '')
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/\*(.+?)\*/g, '$1');
  const parts = [
    timeLabel ? `${title} (${timeLabel})` : title,
    story.url,
    summary,
  ].filter(Boolean);
  return parts.join('\n');
}
